import { render, staticRenderFns } from "./TheInserzione.vue?vue&type=template&id=36065274&scoped=true"
var script = {}
import style0 from "./TheInserzione.vue?vue&type=style&index=0&id=36065274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36065274",
  null
  
)

export default component.exports